import { Pagination } from 'antd';
import { RefreshCw } from 'feather-icons-react/build/IconComponents';
import { Link } from "react-router-dom";
import React, { useEffect, useState } from 'react'
import Table from '../../../core/pagination/datatable'
import { getProductBOQlist } from '../../../services/MasterApiServices';

function ItemWiseProfit() {
  const [itemWiseProfitData, setItemWiseProfitData] = useState([]);
    useEffect(() => {
      handleSaleReportList()
    }, [])
    
    const handleSaleReportList = async ()  =>{
      try {
        const response = await getProductBOQlist();
        setItemWiseProfitData(response)
        console.log(response);
    } catch (error) {
        console.log(error);
    }
      }
   
   
    const columns = [
      {
        title: "Item Name",
        dataIndex: "itemName",
        sorter: (a, b) => a.Name?.length - b.Name?.length,
      },
      {
        title: "Total Qty",
        dataIndex: "totalQty",
        sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
      },
      {
        title: "Cost Price",
        dataIndex: "costPrice",
        sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
      },
     
      {
      title: "Sale Price",
      dataIndex: "salePrice",
      sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
      },
      {
        title: "Total Cost Price",
        dataIndex: "totalCostPrice",
        sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
        },
        {
            title: "Total Sale Price",
            dataIndex: "totalSalePrice",
            sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
            },
            {
              title: "Profit",
              dataIndex: "profit",
              sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
            },
            {
              title: "Gross Profit",
              dataIndex: "grossProfit",
              sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
            },
            {
              title: "MarkUp",
              dataIndex: "markUp",
              sorter: (a, b) => a.Percentage?.length - b.Percentage?.length,
            },
    ];
  return (
    <div>
        <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Item Wise Profit</h4>
              </div>
            </div>
            <ul className="table-top-head">
              </ul>
            <div className="d-flex purchase-pg-btn">
              <div className="page-btn">
               
              </div>
              <div className="page-btn import">
                <Link
                  to="#"
                  className="btn btn-added color"
                  data-bs-toggle="modal"
                  data-bs-target="#view-notes"
                >
                  <RefreshCw className="me-2" />
                  Refresh
                </Link>
              </div>
            </div>
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-body">
             
              {/* /Filter */}
              
              {/* /Filter */}
              <div className="table-responsive product-list">
                <Table columns={columns} dataSource={itemWiseProfitData} />
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
      </div>
      <Pagination />
    </div>
  )
}

export default ItemWiseProfit